// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const SideMenu = () => {
//   const [isMenuOpen, setMenuOpen] = useState(true); // State to track menu visibility

//   const toggleMenu = () => {
//     setMenuOpen(!isMenuOpen); // Toggle menu state
//   };

//   return (
//     <div className="d-flex">
//       {/* Side Menu */}
//       <div
//         className={`sidebar bg-light border-right ${isMenuOpen ? 'open' : 'collapsed'}`} // Toggle between 'open' and 'collapsed' states
//         id="sidebar-wrapper"
//       >
//         <div className="sidebar-heading">Configuration</div>
//         <div className="list-group list-group-flush">
//           <Link to="/admin/religion" className="list-group-item list-group-item-action bg-light">Manage Religion</Link>
//           <Link to="/admin/religion/create" className="list-group-item list-group-item-action bg-light">Add Religion</Link>
//           {/* <Link to="/admin/caste" className="list-group-item list-group-item-action bg-light">Manage Caste</Link>
//           <Link to="/admin/caste/create" className="list-group-item list-group-item-action bg-light">Add Caste</Link>

//           <Link to="/admin/subcaste" className="list-group-item list-group-item-action bg-light">Manage SubCaste</Link>
//           <Link to="/admin/subcaste/create" className="list-group-item list-group-item-action bg-light">Add SubCaste</Link> */}
//         </div>
//       </div>

//       {/* Toggle Button in Navbar */}
//       <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom">
//         <button className="btn btn-primary" id="menu-toggle" onClick={toggleMenu}>
//           {isMenuOpen ? 'Hide Menu' : 'Show Menu'}
//         </button>
//       </nav>
//     </div>
//   );
// };

// export default SideMenu;


import React from 'react';

const SideMenu = () => {
  return null;
};

export default SideMenu;